import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  Button,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { motion } from "framer-motion";
import locationIcon from "../../Assets/Icons/locationIcon.svg";
import bedIcon from "../../Assets/Icons/hotelicon.svg";
import showerIcon from "../../Assets/Icons/showericon.svg";
import SearchIcon from "@mui/icons-material/Search";

// Import specific assets
import card1 from "../../Assets/image1.svg";
import card2 from "../../Assets/image2.svg";
import card3 from "../../Assets/image3.svg";

const RealEstateSearch = () => {
  const propertyData = [
    {
      id: 1,
      title: "Emerald Heights",
      location: "Worli, Mumbai",
      price: "₹ 4.50 Cr", 
      beds: 3,
      baths: 3,
      status: "RESALE",
      image: card1,
    },
    {
      id: 2,
      title: "Abilio Horizon",
      location: "Bandra West",
      price: "₹ 8.20 Cr",
      beds: 4,
      baths: 4,
      status: "NEW LAUNCH",
      image: card2,
    },
    {
      id: 3,
      title: "Parkview Residences",
      location: "Powai, Mumbai",
      price: "₹ 2.10 Cr",
      beds: 2,
      baths: 2,
      status: "RESALE",
      image: card3,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#FFFFFF",
        pt: { xs: "48px", sm: "56px", lg: "80px" },
        pb: { xs: "48px", sm: "56px", lg: "80px" },
        opacity: 1,
        overflow: "hidden",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: { xs: "100%", lg: "1312px" },
          pl: { xs: "22px", sm: "32px", md: "46px", lg: "62px" },
          pr: { xs: "20px", sm: "28px", md: "40px", lg: "48px" },
          mx: "auto",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Header - 1216 x 104 */}
        <Stack
          spacing="16px"
          sx={{
            maxWidth: "1216px",
            mx: "auto",
            mb: { xs: "32px", lg: "40px" },
            textAlign: "left",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Manrope",
              fontWeight: 800,
              fontSize: { xs: "28px", sm: "36px", lg: "36px" },
              lineHeight: { xs: "36px", sm: "44px", lg: "56px" },
              letterSpacing: { xs: "-1.4px", lg: "-2.4px" },
              color: "#1C1917",
              textAlign: "center",
            }}
          >
            Find Your Perfect Space
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: { xs: "14px", lg: "16px" },
              lineHeight: "26px",
              color: "#57534E",
              maxWidth: "600px",
              mx: "auto",
              textAlign: "center",
            }}
          >
            Browse our exclusive collection of new developments and premium
            resale flats across the city’s most coveted locations.
          </Typography>
        </Stack>

        {/* Search Bar - 1024 x 97 */}
        <Box
          sx={{
            maxWidth: "1216px",
            mx: "auto",
            mb: { xs: "32px", lg: "48px" },
            backgroundColor: "#FFFFFF",
            borderRadius: "16px",
            textAlign: "center",
            p: { xs: "14px", sm: "18px", md: "20px" },
            boxShadow:
              "0px 10px 15px -3px rgba(0, 0, 0, 0.05), 0px 4px 6px -4px rgba(0, 0, 0, 0.05)",
            border: "1px solid #F3F4F6",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: { xs: "16px", md: "20px", lg: "24px" },
            px: { xs: "16px", sm: "20px", md: "24px" }, 
          }}
        >
          <SearchFilterItem
            label="LOCATION"
            value="Mumbai Metropolitan"
            options={["Mumbai Metropolitan", "Delhi NCR", "Bangalore", "Hyderabad", "Chennai", "Pune"]}
          />
          <SearchFilterItem
            label="PROPERTY TYPE"
            value="Resale Flats"
            options={["Resale Flats", "New Launch", "Commercial", "Luxury Villas", "Penthouse"]}
          />
          <SearchFilterItem
            label="BUDGET RANGE"
            value="1 Cr - 3 Cr"
            options={["50L - 1 Cr", "1 Cr - 3 Cr", "3 Cr - 5 Cr", "5 Cr - 10 Cr", "10 Cr+"]}
          />

          {/* Search Button */}
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            sx={{
              width: { xs: "100%", lg: "235.5px" },
              height: "63px",
              backgroundColor: "#1C1917",
              color: "#FFFFFF",
              borderRadius: "4px",
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "14px",
              textTransform: "none",
              padding: "12px 16px",
              "&:hover": {
                backgroundColor: "#2D2A27",
              },
            }}
          >
            Search Properties
          </Button>
        </Box>

        {/* Images Grid - 1216 x 421 (roughly) */}
        <Grid
          container
          spacing={{ xs: "24px", sm: "28px", md: "32px" }}
          rowSpacing={{ xs: 5, md: 4 }}
          justifyContent="center"
          sx={{
            maxWidth: "1216px",
            mx: "auto",
            width: "100%",
          }}
        >
          {propertyData.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "8px",
                  overflow: "hidden",
                  border: "1px solid #F3F4F6",
                  boxShadow:
                    "0px 10px 15px -3px rgba(0, 0, 0, 0.06), 0px 4px 6px -4px rgba(0, 0, 0, 0.05)",
                }}
              >
                {/* Image Section - 384 x 256 */}
                <Box
                  sx={{
                    width: "100%",
                    height: "256px",
                    position: "relative",
                    backgroundColor: "#F3F4F6",
                  }}
                >
                      <motion.img
                    src={item.image}
                    alt={item.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                  {/* Status Badge */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "16px",
                      left: "16px",
                      backgroundColor:
                        item.status === "NEW LAUNCH"
                          ? "#44403C"
                          : "#B02F00",
                      color: "#FFFFFF",
                      padding: "4px 8px",
                      borderRadius: "2px",
                      fontSize: "10px",
                      fontWeight: 700,
                      fontFamily: "Inter",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {item.status}
                  </Box>
                </Box>

                {/* Content Section - 384 x 164.5 */}
                <Box
                  sx={{
                    p: { xs: "22px", md: "28px" },
                    display: "flex",
                    flexDirection: "column",
                    gap: "7.5px",
                    textAlign: "left",
                    alignItems: "flex-start",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Manrope",
                      fontWeight: 700,
                      fontSize: "18px",
                      color: "#1C1917",
                      width: "100%",
                      textAlign: "left",
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={0.5}
                    sx={{ mb: 1 }}
                  >
                    <img
                      src={locationIcon}
                      alt="location"
                      style={{
                        width: "14px",
                        height: "14px",
                        objectFit: "contain",
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "14px",
                        color: "#57534E",
                        width: "100%",
                        textAlign: "left",
                      }}
                    >
                      {item.location}
                    </Typography>
                  </Stack>

                  <Box
                    sx={{
                      borderTop: "1px solid #F3F4F6",
                      pt: "16px",
                      mt: "auto",
                      width: "100%",
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography
                        sx={{
                          fontFamily: "Manrope",
                          fontWeight: 800,
                          fontSize: "20px",
                          color: "#1C1917",
                        }}
                      >
                        {item.price}
                      </Typography>
                      <Stack direction="row" spacing={1.5} alignItems="center">
                        <Stack
                          direction="row"
                          spacing={0.5}
                          alignItems="center"
                        >
                          <img
                            src={bedIcon}
                            alt="beds"
                            style={{
                              width: "16px",
                              height: "16px",
                              objectFit: "contain",
                            }}
                          />
                          <Typography
                            sx={{
                              fontFamily: "Inter",
                              fontSize: "12px",
                              color: "#57534E",
                            }}
                          >
                            {item.beds}
                          </Typography>
                        </Stack>
                        <Stack
                          direction="row"
                          spacing={0.5}
                          alignItems="center"
                        >
                          <img
                            src={showerIcon}
                            alt="baths"
                            style={{
                              width: "16px",
                              height: "16px",
                              objectFit: "contain",
                            }}
                          />
                          <Typography
                            sx={{
                              fontFamily: "Inter",
                              fontSize: "12px",
                              color: "#57534E",
                            }}
                          >
                            {item.baths}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

// Sub-component for search filters
const SearchFilterItem = ({ label, value, options = [] }) => {
  const [selectedValue, setSelectedValue] = React.useState(value);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <FormControl
      sx={{
        width: { xs: "100%", lg: "235.5px" },
        height: "63px",
      }}
    >
      <Typography
        sx={{
          fontSize: "10px",
          fontWeight: 700,
          color: "#A8A29E",
          fontFamily: "Inter",
          letterSpacing: "0.5px",
          mb: "4px",
          textAlign: "left",
          pl: "8px",
        }}
      >
        {label}
      </Typography>
      <Select
        value={selectedValue}
        onChange={handleChange}
        variant="outlined"
        sx={{
          height: "36px",
          backgroundColor: "#F9FAFB",
          borderRadius: "4px",
          fontFamily: "Inter",
          fontSize: "14px",
          fontWeight: 600,
          color: "#1C1917",
          textAlign: "left",
          "& .MuiSelect-select": {
            textAlign: "left",
            paddingLeft: "8px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E7E5E4",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D6D3D1",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#B02F00",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              textAlign: "left",
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option} sx={{ textAlign: "left" }}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default RealEstateSearch;
